import { render, staticRenderFns } from "./ArticleNotification.vue?vue&type=template&id=e7e83628&scoped=true"
import script from "./ArticleNotification.vue?vue&type=script&lang=js"
export * from "./ArticleNotification.vue?vue&type=script&lang=js"
import style0 from "./ArticleNotification.vue?vue&type=style&index=0&id=e7e83628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e83628",
  null
  
)

export default component.exports